import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Accordion from 'react-bootstrap/Accordion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faLink,
  faHeart as faHeartSolid,
} from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import isEmpty from 'lodash.isempty';
// import Button from 'react-bootstrap/Button'
// import Form from 'react-bootstrap/Form'
import Toast from './Toast';
import UtilFunctions from '../UtilFunctions';
import serviceauth from '../auth/serviceauth';
import AdminUtils from '../admin/AdminUtils';

// import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';

class CourseItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    // this.handleKeyDown = this.handleKeyDown.bind(this)
    this.state = {
      // collapse: this.props.collapse ? true : false,
      collapse: !!(this.props?.collapse && this.props.collapse === 'N'),
      hiddenCourseUrl: '',
      toast: false,
      linkJustCopied: false, // Track whether link was just copied for accessibility feedback
      favorited: findIfThisCourseIsFavorited(
        props.favorites,
        props.course.SUBJECT + props.course.CATALOGNBR
      ),
      favoriteJustToggled: false, // Track whether favorite was just toggled for accessibility feedback
    };
    this.hiddenCourseUrl = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleCopyLink = this.handleCopyLink.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
    // console.log("constructor")
  }

  componentDidUpdate(prevProps) {
    if (prevProps.favorites !== this.props.favorites) {
      const courseId = this.props.course.SUBJECT + this.props.course.CATALOGNBR;
      const isFavorited = findIfThisCourseIsFavorited(
        this.props.favorites,
        courseId
      );
      this.setState({ favorited: isFavorited });
    }
  }

  handleClick() {
    this.setState((prevState) => {
      // console.log(prevState.collapse)
      return { collapse: !prevState.collapse };
    });
  }

  handleCopyLink(e, subject, catalogNbr) {
    // console.log(window.location.href.split('?')[0])
    e.stopPropagation();
    const url =
      window.location.href.split('?')[0] +
      '?subject=' +
      subject +
      '&catalogNbr=' +
      catalogNbr +
      '&term=' +
      this.props.term +
      '&collapse=N';
    // console.log(url)
    this.setState(
      {
        hiddenCourseUrl: url,
        toast: true,
      },
      () => {
        this.hiddenCourseUrl.current.select();
        document.execCommand('copy'); //copy to clipboard
        this.hiddenCourseUrl.current.blur();
      }
    );
  }

  handleCopyToClipboard() {
    /* empty */
  }

  async handleFavoriteClick(e) {
    e.preventDefault();
    e.stopPropagation();

    //if user is not authenticated, force authentication
    if (!sessionStorage.getItem(serviceauth.SS_NAME)) {
      window.location.replace(serviceauth.redirectToServiceauthUrl(true));
    } else {
      // If this is a keydown event, only trigger on Spacebar or Enter
      if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;

      let success = await updateCourseFavorites(
        !this.state.favorited,
        this.props.course.SUBJECT + this.props.course.CATALOGNBR,
        this.props.term
      );

      if (success) {
        this.setState({
          favorited: !this.state.favorited,
          favoriteJustToggled: true, // Mark that favorite was just toggled
        });

        // Clear the "just toggled" state after a few seconds
        setTimeout(() => {
          this.setState({ favoriteJustToggled: false });
        }, 3000);

        // Refresh favorites data in parent component
        if (this.props.onFavoriteChange) {
          this.props.onFavoriteChange();
        }
      }
    }
  }

  render() {
    const course = this.props.course;
    //  console.log(JSON.stringify(this.props.seatList))
    return (
      <React.Fragment>
        <textarea
          value={this.state.hiddenCourseUrl}
          className="hidden-course-url"
          onChange={(e) => this.handleCopyToClipboard()}
          ref={this.hiddenCourseUrl}
          tabIndex={-1}
          aria-label="Course Url Link"
        />

        <Row onClick={this.handleClick} className="pointer">
          <Col xs={12} sm={11} className="ps-0">
            <Row className="gx-0">
              <Col
                xs={12}
                sm={2}
                className="d-none d-sm-block font-weight-bold ps-1"
              >
                <span className="sr-only">Course: </span>
                {course.SUBJECT} {course.CATALOGNBR}
                {/* <FontAwesomeIcon
                  icon={this.state.favorited ? faHeartSolid : faHeartRegular}
                  className="ms-1 pointer border-asu border-focus"
                  onClick={this.handleFavoriteClick}
                  tabIndex={0}
                  onKeyDown={this.handleFavoriteClick}
                /> */}
                <button
                  onClick={this.handleFavoriteClick}
                  onKeyDown={(e) => {
                    if (e.key === ' ' || e.key === 'Enter') {
                      e.stopPropagation();
                      e.preventDefault();
                      this.handleFavoriteClick(e);
                    }
                  }}
                  className="btn p-0 border-0 bg-transparent ms-1 "
                  aria-pressed={this.state.favorited}
                  aria-label={
                    this.state.favoriteJustToggled
                      ? `${
                          this.state.favorited ? 'Added to' : 'Removed from'
                        } favorites`
                      : this.state.favorited
                        ? 'Remove from favorites'
                        : 'Add to favorites'
                  }
                >
                  <FontAwesomeIcon
                    className=" pointer border-asu border-focus"
                    icon={this.state.favorited ? faHeartSolid : faHeartRegular}
                  />
                </button>
              </Col>

              <Col xs={12} sm={7} className="">
                <p className="mb-1 title font-weight-bold ">
                  <span className="sr-only">Course title: </span>
                  {course.COURSETITLELONG}
                </p>
                <p className="d-block d-sm-none ">
                  <span className="sr-only">Course: </span>
                  {course.SUBJECT} {course.CATALOGNBR}
                </p>
                <p className="">{course.DESCRLONG}</p>
                <p className="d-block d-sm-none asu-font-color">
                  <span>
                    {this.state.collapse ? 'SHOW LESS' : 'LEARN MORE'}
                  </span>
                  <FontAwesomeIcon
                    icon={this.state.collapse ? faChevronUp : faChevronDown}
                    className="pull-right"
                    aria-hidden="true"
                  />
                </p>
              </Col>
              <Col className="d-none d-sm-block text-center" sm={1}>
                <span className="sr-only">Units: </span>
                {course.HOURS}
              </Col>
              <Col className=" text-center" sm={1}>
                <span className="sr-only">General Studies: </span>
                {UtilFunctions.getGSDesignationsDisplay(
                  course.GSMAROON,
                  course.GSGOLD
                )}
              </Col>
              <Col sm={1} className="text-center">
                <button
                  className="pull-right d-none d-sm-block button-link black"
                  tabIndex="0"
                  aria-label={`${
                    this.state.collapse ? 'Collapse' : 'Expand'
                  } course details for ${course.SUBJECT} ${course.CATALOGNBR}`}
                  aria-expanded={this.state.collapse}
                >
                  <FontAwesomeIcon
                    icon={this.state.collapse ? faChevronUp : faChevronDown}
                  />
                </button>
              </Col>
            </Row>

            <Row className={this.state.collapse ? '' : 'd-none'}>
              <Col
                xs={12}
                sm={{ span: 11, offset: 2 }}
                className="align-self-end ps-1"
              >
                <hr className="d-block d-sm-none" />
                <p className=" d-sm-block mb-1 font-weight-bold">Units</p>
                <p className=" d-sm-block">
                  <span className="sr-only">Units: </span>
                  {course.HOURS}
                </p>

                {course.DESCR4 !== '' && (
                  <>
                    <p className="pt-1">
                      {UtilFunctions.getGSText(course.GSMAROON, course.GSGOLD)}
                    </p>
                  </>
                )}

                <p className=" mb-1 font-weight-bold">
                  Offering Schools/Colleges
                </p>
                {course.COLLEGEMAP &&
                  course.COLLEGEMAP.map((org, index) => {
                    return (
                      !isEmpty(org) && (
                        <div key={index}>
                          <p>
                            <a
                              href={org.INFO.ASUCOLLEGEURL}
                              className="asulink"
                            >
                              {org.INFO.DESCRFORMAL + ' - ' + org.DEPARTMENT}
                            </a>
                          </p>
                          {org.INFO.ENROLLREQ !== '' && (
                            <React.Fragment>
                              {/* <p className="text-secondary mb-1">Pre-requisite(s)</p> */}
                              <p className="ps-3">{org.INFO.ENROLLREQ}</p>
                            </React.Fragment>
                          )}
                        </div>
                      )
                    );
                  })}

                <div className="mb-3">{getTopicsList(course)}</div>

                <p className=" mb-1 font-weight-bold">
                  Allow multiple enrollments
                </p>
                <p>
                  <span className="sr-only">Allow multiple enrollments: </span>
                  {course.ALLOWMULTENROLL === 'Y' ? 'Yes' : 'No'}
                </p>

                <p className=" mb-1 font-weight-bold">Repeatable for credit</p>
                <p>
                  <span className="sr-only">Repeatable for credit: </span>
                  {course.CRSEREPEATABLE === 'Y' ? 'Yes' : 'No'}
                </p>

                <p className=" mb-1 font-weight-bold">
                  Primary course component
                </p>
                <p>
                  <span className="sr-only">Primary course component: </span>
                  {course.COMPONENTDESCR}
                </p>

                <p className=" mb-1 font-weight-bold">Grading method</p>
                <p>
                  <span className="sr-only">Grading method: </span>
                  {course.GRADINGBASISDESCR}
                </p>
                <p>
                  <button
                    className="button-link underline mt-2 "
                    onClick={(e) =>
                      this.handleCopyLink(e, course.SUBJECT, course.CATALOGNBR)
                    }
                  >
                    <FontAwesomeIcon icon={faLink} className="" />
                    <span className="ms-1">Copy Course Link</span>
                  </button>
                </p>
                <Toast show={this.state.toast} text="Copied to Clipboard!" />
              </Col>
              {/* </Accordion.Collapse> */}
            </Row>
            {/* </Accordion> */}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default CourseItem;

function getTopicsList(course) {
  var topics = [];
  if (course.TOPICSLIST && course.TOPICSLIST.length > 0) {
    topics.push(<p className=" mb-1 font-weight-bold">Topics</p>);
    for (let index = 0; index < course.TOPICSLIST.length; index++) {
      const topic = course.TOPICSLIST[index];
      topics.push(<p className="mb-1">{topic}</p>);
    }
  }
  return topics;
}

function findIfThisCourseIsFavorited(allFavorites, thisCourseId) {
  return allFavorites?.some((fav) => fav.id === thisCourseId) || false;
}

async function updateCourseFavorites(favorite, id, term) {
  const url = favorite
    ? UtilFunctions.getAddToFavoritesUrl()
    : UtilFunctions.getRemoveFromFavoritesUrl();

  const body = JSON.stringify({ term, id, type: 'course' });

  try {
    let response = await fetch(
      AdminUtils.getRequestObject(url, 'POST', body)
    );

    // On 401, try refreshing the token and retry once
    if (response.status === 401) {
      serviceauth.getRefreshedAccessToken();

      // Check if token was actually refreshed
      const newToken = sessionStorage.getItem(serviceauth.SS_JWT_TOKEN);
      if (newToken) {
        response = await fetch(
          AdminUtils.getRequestObject(url, 'POST', body)
        );

        if (response.status === 401) {
          serviceauth.reauth();
          return false;
        }
      } else {
        serviceauth.reauth();
        return false;
      }
    }

    return response.status === 200;
  } catch (err) {
    console.log(err);
    return false;
  }
}

// function decodeKeywordMatch(course){
//     console.log("Class Item render")

//     var match = course.KEYWORDMATCH.description

//     if(match != null){
//         match = match.replace("ConstantScore","").replace(/\(/g,"").replace(/\)/g,"").replace(" -"," --and NOT ")
//         match = match.replace(/ \+/g," --and ").replace(/\+/g,"").replace(/:/g, ":  ")
//         var matches =  match.split("--");

//         if(match.indexOf("KEYWORDSEARCHSTR") >= 0){
//             matches.push("Keyword Text: "+course.CLAS.KEYWORDSEARCHSTR)
//         }

//         return matches
//     }

//     return [];
// }
